import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { BaseModalComponent } from '@app/components/base-modal/base-modal.component';
import { CustomDateRangeData } from '../models/custom-date-range-data.model';
import { startEndRangeValidator } from '@app/validators/date.validators';

@Component({
  standalone: true,
  selector: 'app-custom-date-range-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatInputModule,
    BaseModalComponent,
    MatNativeDateModule,
  ],
  templateUrl: './custom-date-range-dialog.component.html',
  styleUrls: ['./custom-date-range-dialog.component.scss'],
})
export class CustomDateRangeDialogComponent {
  protected dateForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<CustomDateRangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CustomDateRangeData,
    private formBuilder: FormBuilder,
  ) {
    this.dateForm = this.formBuilder.group(
      {
        dateStart: [data.startDate || null, Validators.required],
        dateEnd: [data.endDate || null, Validators.required],
      },
      { validators: startEndRangeValidator },
    );
  }

  protected onCancel(): void {
    this.dialogRef.close(null);
  }

  protected onApply(): void {
    if (this.dateForm.valid) {
      this.dialogRef.close({
        startDate: this.dateForm.value.dateStart,
        endDate: this.dateForm.value.dateEnd,
      });
    }
  }
}
